import 'css-chunksrc/client/common/portfolioAssignation/projectPortfolio/styles.scss';export default {
  "projectPortfolio": "_projectPortfolio_1d9xm_1"
};